<template>
  <div />
</template>

<script>
import { mapActions } from 'vuex'
import Profile from '@/api/profile/Profile'

export default {
  name: 'VerifyInvitation',

  layout: 'DefaultLayout',

  async created() {
    try {
      const { data } = await Profile.verifyInvitation(
        this.$route.query.email,
        this.$route.query.token
      )

      if (data.registration_required) {
        this.registerUser(data)
        return
      }

      if (data.authentication_required) {
        window.location.href = '/signin?reason=authentication_required'
        this.success('You already have an account. Please login.')

        return
      }

      await this.fetchUser()

      this.$router.replace(
        { name: 'leave-summary', query: { company: data.company_id } },
        () => {}
      )
      this.success('Your invitation has been successfully accepted.')
    } catch (error) {
      window.location.href = '/signin?reason=invalid_token'
      this.error('Invitation token is invalid.')
    }
  },

  methods: {
    ...mapActions('auth', ['fetchUser']),

    async registerUser(data) {
      const email = data.employment.email
      const full_name = data.employment.full_name

      const queryParams = new URLSearchParams({
        ...this.$route.query,
        invited: true,
        email,
        full_name,
      })

      window.location.href = `/signup?${queryParams.toString()}`
    },
  },
}
</script>
